import { Order } from '../Table/types';
import { getSortValue } from '../Table/utils/sorting';
import { Row } from './types';

const comparatorByName = (a: Row['cells'], b: Row['cells']) => {
  const nameA = getSortValue(a.name);
  const nameB = getSortValue(b.name);

  return nameA.localeCompare(nameB);
};

const comparatorByStatus = (
  a: Row['cells'],
  b: Row['cells'],
  orderCoef: number
) => {
  const userA = getSortValue(a.status);
  const userB = getSortValue(b.status);

  const equivalentCoef = userA.localeCompare(userB);

  if (!equivalentCoef) {
    return orderCoef * comparatorByName(a, b);
  }
  return equivalentCoef;
};

export const sortColumns = (
  order: Order,
  orderBy: string
): ((a: Row['cells'], b: Row['cells']) => number) => {
  const orderCoef = order === Order.Desc ? -1 : 1;

  switch (orderBy) {
    case 'name':
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByName(a, b);
    case 'status':
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByStatus(a, b, orderCoef);
    default:
      return (a: Row['cells'], b: Row['cells']) =>
        orderCoef * comparatorByName(a, b);
  }
};
